import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AppConfig } from '../config/app-config';
import { ValidFor } from '../models/validFor';

@Injectable({
  providedIn: 'root'
})
export class ActivationService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content - Type': 'application / json; charset=uft-8'
    })
  };

  constructor(private http: HttpClient, public translate: TranslateService,private appConfig: AppConfig) {}

  GetValidFor(): Observable<ValidFor[]> {    
    return this.http.get<any>(this.appConfig.urlKeysApi + "Activation/GetValidFor");
  }

  //requestActivation(reqAct: Activation): Observable<any> {
  //  return this.http.get<any>(this.baseUrl + "Activation/RequestActivation", reqAct);
  //  //const uploadReq = new HttpRequest('POST', this.baseUrl + "Activation/RequestActivation", reqAct);
  //  //return this.http.request(uploadReq);
  //}

  requestActivation(reqAct) : Observable<any> {
    return this.http.post(this.appConfig.urlKeysApi + "Activation/RequestActivation", reqAct);
  }

    requestCrypt(text: string): Observable<any> {
        let params = new HttpParams()
            .set("text", text !== null ? text.toString() : '');

        return this.http.get<any>(this.appConfig.urlKeysApi + 'Activation/RequestCrypt', { params: params })
    }

}
